import { PayItemsOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import { useFDCTrackerContext } from '../../../FDCTrackerContext'
import { FieldDesignChange } from '../../../FDCTrackerContext/types'

export function usePayItemsOptions(): PayItemsOptions<FieldDesignChange> {
  const { payItemGlobalId } = useFDCTrackerContext()
  return {
    hidden: !!payItemGlobalId,
    globalId: payItemGlobalId,
    onFilter: (value, { fdcToPayItemNoGeometries }) =>
      fdcToPayItemNoGeometries.some(
        ({ payItem: { globalId } }) => value === globalId
      ),
  }
}
